import angular from 'angular';
import { debounce, throttle } from 'lodash';

import _css from './od-lazy-element.less';

// TODO(azirbel): This badly needs tests. I'm not even sure it's working
// anymore.

// od-lazy-element
//
// An element that sets `lazyLoad=true` on its own scope once you scroll near
// it. "Near it" means within 100vh of it.
module.exports = angular.module('common.directives.od-lazy-element', [])
.directive('odLazyElement', ($window, $document, $timeout) => {
  class OdLazyElement {
    constructor($element, $scope) {
      this.$element = $element;
      this.$scope = $scope;

      var windowEl = angular.element($window);
      var throttledOnScroll = throttle(() => {
        this.onScroll();
      }, 10);
      var debouncedRebuild = debounce(() => {
        this.rebuild();
      }, 300, { leading: true });

      // Extra rebuilds during scroll so we can still recover if other things
      // on the page change during scroll. Sneaky elements could appear, ng-if
      // could pull things in and out of the DOM, etc.
      windowEl.on('scroll', throttledOnScroll);
      windowEl.on('scroll', debouncedRebuild);
      windowEl.on('resize', debouncedRebuild);
      $scope.$on('$destroy', function() {
        windowEl.off('scroll', throttledOnScroll);
        windowEl.off('scroll', debouncedRebuild);
        windowEl.off('resize', debouncedRebuild);
      });

      // Make sure the internal state is at least initialized
      this.rebuild();

      // Update the internal state correctly, once the DOM is actually ready
      $timeout(() => {
        this.rebuild();
        this.onScroll();
      });
    }

    rebuild() {
      // Only need to lazy-load once.
      if (this.$scope.lazyLoad) {
        return;
      }

      this.distanceFromTopOfPage =
          this.$element[0].getBoundingClientRect().top + $window.scrollY;
      this.viewportHeight = $window.innerHeight;
    }

    onScroll() {
      // Only need to lazy-load once.
      if (this.$scope.lazyLoad) {
        return;
      }

      if ($window.scrollY + (this.viewportHeight * 2) >= this.distanceFromTopOfPage) {
        this.$scope.lazyLoad = true;

        // HACK
        this.$scope.$digest();
      }
    }
  }

  return {
    restrict: 'EA',
    controller: OdLazyElement,
    bindToController: true,
    controllerAs: 'lazyElementCtrl',
    scope: true
  };
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-lazy-element.js
 **/